import request from '@/utils/request';

export const frontFnMenu = (data) => {
  return request({
    url: '/front/fnMenu',
    method: 'post',
    data
  })
}

export const frontArticles4Memu = (data) => {
  return request({
    url: '/front/articles4Memu',
    method: 'post',
    data
  })
}

export const frontGetArticle = (data) => {
  return request({
    url: '/front/getArticle',
    method: 'post',
    data
  })
}

export const frontFnMenu2 = (data) => {
  return request({
    url: '/front/fnMenu2',
    method: 'post',
    data
  })
}

export const frontThrMenu = (data) => {
  return request({
    url: '/front/thrMenu',
    method: 'post',
    data
  })
}